<template>
  <el-dialog
    :title="$t('mainCategory.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center">
      <p>{{ $t('mainCategory.confirmDeleteCategory') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('mainCategory.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteMainCategory">
        {{ $t('mainCategory.confirmDelete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMainCategory } from '@/api/admin/mainCategory/mainCategoryApi'

export default {
  name: 'DeleteMainCategory',
  data() {
    return {
      dialogVisible: false,
      deleteMainCategoryInfo: {
        mainCategoryId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.deleteMainCategoryInfo.mainCategoryId = data.mainCategoryId
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteMainCategoryInfo = { mainCategoryId: '' }
    },
    async deleteMainCategory() {
      try {
        await deleteMainCategory(this.deleteMainCategoryInfo)
        this.$message.success(this.$t('mainCategory.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>